import { FiMenu } from "react-icons/fi";
import Buttons from "../../../components/button";
import { PanelService } from "../../../components/services/panel.service";
import { CompanyLogo } from "./company-logo";

export const HeaderLogo = (props: {
  logo: string;
  sidebar?: React.ReactNode;
}) => {
  return (
    <div className="flex items-center">
      <span className="hidden lg:flex">
        <CompanyLogo src={props.logo} alt="Company Logo" />
      </span>
      {props.sidebar ? (
        <span className="lg:hidden">
          <Buttons.Base
            variant="ghost"
            className="w-11 h-11"
            onClick={() => {
              PanelService.open(() => props.sidebar, {
                width: Math.min(window.innerWidth, 300),
              });
            }}
          >
            <FiMenu />
          </Buttons.Base>
        </span>
      ) : null}
    </div>
  );
};
